// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Practitioner registration payload.
 * @see #/components/schemas/PractitionerRegistrationRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface PractitionerRegistrationRequest {
    /**
     * The code needed for user setup
     *
     */
    pin: string;
    /**
     * The value of the RFID chip that is linked to the practitioner
     *
     */
    rfid: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for PractitionerRegistrationRequest
 */
export namespace PractitionerRegistrationRequest {
    /**
     * PractitionerRegistrationRequest Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The code needed for user setup
         * @type string (`dataFormat` is missing)
         */
        pin: string;
        /**
         * The value of the RFID chip that is linked to the practitioner
         * @type string (`dataFormat` is missing)
         */
        rfid: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * PractitionerRegistrationRequest DTO
     * Transforms PractitionerRegistrationRequest model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend PractitionerRegistrationRequest model */
        static toModel(obj: PractitionerRegistrationRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend PractitionerRegistrationRequest model */
        static toApi(obj: Model): PractitionerRegistrationRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as PractitionerRegistrationRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
